/** Shapes of the admin API `/api/api-keys/*` (lane B8 backend, see docs/modules/public-api.md). */

export const API_SCOPES = [
  'messages:send',
  'messages:read',
  'messages:send_phone',
  'clients:read',
  'groups:read',
  'templates:read',
  'webhooks:manage',
] as const;
export type ApiScope = (typeof API_SCOPES)[number];

export const SCOPE_LABELS_HE: Record<ApiScope, string> = {
  'messages:send': 'שליחת הודעות',
  'messages:read': 'קריאת סטטוס הודעות',
  'messages:send_phone': 'שליחה לפי מספר טלפון (רק לאנשי קשר שכתבו אלינו)',
  'clients:read': 'קריאת לקוחות',
  'groups:read': 'קריאת קבוצות',
  'templates:read': 'קריאת תבניות',
  'webhooks:manage': 'ניהול Webhooks',
};

export type ApiKeyStatus = 'active' | 'test' | 'rotating' | 'expired' | 'revoked';

export interface ApiKeyView {
  id: string;
  name: string;
  prefix: string;
  isTest: boolean;
  scopes: ApiScope[];
  dailyQuota: number;
  ratePerMin: number;
  ipAllowlist: string[];
  status: ApiKeyStatus;
  lastUsedAt: string | null;
  expiresAt: string | null;
  revokedAt: string | null;
  rotatedFromId: string | null;
  replacedById: string | null;
  createdAt: string;
  createdBy: { id: string; name: string } | null;
  requestsToday: number;
}

export interface CreateApiKeyBody {
  name: string;
  isTest: boolean;
  scopes: ApiScope[];
  dailyQuota: number;
  ratePerMin: number;
  ipAllowlist: string[];
  expiresAt: string | null;
  totpCode: string;
}

export interface CreateApiKeyResult {
  apiKey: ApiKeyView;
  key: string;
  callbackSecret: string;
}

export interface RotateApiKeyResult {
  apiKey: ApiKeyView;
  key: string;
  previous: { id: string; expiresAt: string };
}

export interface ApiKeyUsage {
  apiKeyId: string;
  lastUsedAt: string | null;
  dailyQuota: number;
  quotaUsedToday: number;
  today: { total: number; byStatus: Record<string, number> };
  last7Days: { day: string; total: number; errors: number }[];
}

export interface ApiRequestRow {
  id: string;
  at: string;
  apiKeyId: string;
  keyName: string;
  keyPrefix: string;
  method: string;
  path: string;
  statusCode: number;
  errorCode: string | null;
  note: string | null;
  durationMs: number;
}

export interface WebhookSubscriptionRow {
  id: string;
  url: string;
  events: string[];
  enabled: boolean;
  disabledAt: string | null;
  failureCount: number;
  createdAt: string;
  apiKeyId: string;
  keyName: string;
  keyPrefix: string;
  deliveries24h: { delivered: number; pending: number; failed: number };
}

export interface WebhookDeliveryRow {
  id: string;
  eventId: string;
  eventType: string;
  url: string;
  subscriptionId: string | null;
  messageId: string | null;
  status: 'pending' | 'delivered' | 'failed';
  attempts: number;
  lastStatusCode: number | null;
  lastError: string | null;
  nextAttemptAt: string | null;
  deliveredAt: string | null;
  createdAt: string;
}

/** What the "shown once" modal displays after create / rotate. */
export interface OneTimeSecret {
  title: string;
  keyName: string;
  key: string;
  callbackSecret?: string;
  previousExpiresAt?: string;
}
